import { type FilterAiOptions_Response, FilterAiOptions_Response_Status } from '@zendesk/zqa-services/filters'
import { api } from '@/api'
import { session } from '@/composables/useSession'

export { FilterAiOptions_Response_Status as AiFilterStatus }

export function getAiFilterOptions(prompt: string, signal?: AbortSignal): Promise<FilterAiOptions_Response> {
  return api
    .post('filter/ai-options', {
      headers: { 'X-Klaus-Workspace': session.workspace.id.toString() },
      json: { prompt },
      signal,
    })
    .json()
}
